import { apiInterface } from '@/api/interfaces'
import AbstractApi from '@/api/abstract'
import { servicesApiReq, servicesApiRes } from './interfaces'

class ServicesApi implements apiInterface.IServicesApi {
  ctx: AbstractApi

  constructor(ctx: AbstractApi) {
    this.ctx = ctx
  }

  getServices = async (
    params: servicesApiReq.IGetServicesReq = {}
  ): Promise<servicesApiRes.IGetServicesRes[]> => {
    const res = await this.ctx.get<
      servicesApiReq.IGetServicesReq,
      servicesApiRes.IGetServicesRes[]
    >('/services/', params)
    return res.data
  }
}

export default ServicesApi
